import SeoKeywordDetail from './SeoKeywordDetail.container';

export default SeoKeywordDetail;
